const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/quizzes",
    exact: true,
    component: "Quizzes", // ✅ New Quizzes page
  },
  {
    path: "/quiz/:slug",
    exact: true,
    component: "QuizPage", // ✅ Existing Quiz details page
  },
  {
    path: "/pricing",
    exact: true,
    component: "Pricing",
  },
  {
    path: "/account",
    exact: true,
    component: "Account",
  },
  {
    path: "/progress",
    exact: true,
    component: "Progress",
  },
  {
    path: "/signin",
    exact: true,
    component: "SignIn",
  },
  {
    path: "/signup",
    exact: true,
    component: "SignUp",
  },
  {
    path: "/forgot-password",
    exact: true,
    component: "ForgotPassword",
  },
  {
    path: "/reset-password",
    exact: true,
    component: "ResetPassword",
  },
  {
    path: "/connect/:provider/redirect",
    exact: true,
    component: "AuthCallback", // OAuth landing (Google / Facebook)
  },
  {
    path: "*",
    component: "NotFound", // ✅ Catch-all 404
  },
];

export default routes;
